import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class ZendeskLiveHandoffMessageRecord
 * @augments BaseMessageRecord
 */
class ZendeskLiveHandoffMessageRecord extends BaseMessageRecord({
  type: "zendesk_live_handoff",

  /**
   * @memberof ZendeskLiveHandoffMessageRecord#
   */
  departmentId: null,
  departmentName: null,
  fallbackResponseId: null
}) {}

/**
 * Validation
 */

/**
 * @param {ZendeskLiveHandoffMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
ZendeskLiveHandoffMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (!message.departmentId) {
    invalidFields.add("departmentId");
  }

  if (!message.fallbackResponseId) {
    invalidFields.add("fallbackResponseId");
  }

  return Immutable.List(invalidFields);
};

export default ZendeskLiveHandoffMessageRecord;
